import { render, staticRenderFns } from "./DialogConfirmDeleteMemo.vue?vue&type=template&id=15689e2a&"
import script from "./DialogConfirmDeleteMemo.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmDeleteMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports